/**
 * The app's areas that a feature or an update belongs to. A fixed list, because
 * the areas are code. Tables store the keys as text and check them on write.
 *
 * Aliases: feature modules, app modules, module list, module labels
 */

import { z } from "zod";

export const FEATURE_MODULES = [
  "nova",
  "coaching_os",
  "life_by_design",
  "marketing_suite",
  "lead_magnets",
  "content_hub",
  "account",
] as const;

export type FeatureModule = (typeof FEATURE_MODULES)[number];

export const featureModuleSchema = z.enum(FEATURE_MODULES);

export const FEATURE_MODULE_LABELS: Readonly<Record<FeatureModule, string>> = {
  nova: "NOVA",
  coaching_os: "Coaching OS",
  life_by_design: "Life by Design",
  marketing_suite: "Marketing Suite",
  lead_magnets: "Lead magnets",
  content_hub: "Content Hub",
  account: "Account",
};
